import {
  Breadcrumb,
  BreadcrumbGroup,
  Button,
  Column,
  DataTable,
  DataTableBody,
  DataTableCell,
  DataTableHead,
  DataTableHeader,
  DataTableRow,
  Link,
  Row,
  SearchField,
  Text,
} from "@amzn/meridian";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { INSPECTION_TABLE_HEADERS } from "src/constants/constants";
import { inspectionDetails } from "src/data/mockData";

const Dashboard = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const dashboardBreadcrumbs = () => (
    <BreadcrumbGroup>
      <Breadcrumb onClick={() => navigate("/")}>Home</Breadcrumb>
      <Breadcrumb>Dashboard</Breadcrumb>
    </BreadcrumbGroup>
  );

  return (
    <Column>
      <Column>{dashboardBreadcrumbs()}</Column>
      <Column>
        <Text fontFamily="bookerly" type="d50">
          Dashboard
        </Text>
      </Column>
      <Column>
        <Row alignmentHorizontal="justify">
          <SearchField
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Search for..."
            onSubmit={() => {}}
            clearButton={false}
            searchButton={true}
          />
          <Button onClick={() => navigate("/admin/createInspectionTemplate")}>
            Create Inspection
          </Button>
        </Row>
      </Column>
      <Column>
        <Row widths={"fill"}>
          <DataTable
            size="medium"
            showRowDividers={true}
            showColumnDividers={false}
            showStripes={false}
            showBorder={false}
          >
            <DataTableHead>
              <DataTableRow highlightOnHover={false}>
                {INSPECTION_TABLE_HEADERS.map((header) => (
                  <DataTableHeader>{header}</DataTableHeader>
                ))}
              </DataTableRow>
            </DataTableHead>
            <DataTableBody>
              {inspectionDetails.map((inspection, index) => (
                <DataTableRow
                  key={`${inspection.name} at index ${index}`}
                  highlightOnHover={false}
                >
                  <DataTableCell>
                    <Link href="">{inspection.name}</Link>
                  </DataTableCell>
                  <DataTableCell>{inspection.inspectionType}</DataTableCell>
                  <DataTableCell>{inspection.location}</DataTableCell>
                  <DataTableCell>{inspection.frequency}</DataTableCell>
                  <DataTableCell>{inspection.mandate}</DataTableCell>
                  <DataTableCell>{inspection.status}</DataTableCell>
                </DataTableRow>
              ))}
            </DataTableBody>
          </DataTable>
        </Row>
      </Column>
    </Column>
  );
};

export default Dashboard;
